<template>
  <ListSelect
    v-model="value"
    :options="knownProjectSelectables"
    :loading="knownProjectSelectablesLoading"
    :quick-sums="projectQuickSums"
    :quick-sums-loading="projectQuickSumsLoading"
    :filter-quick-sums-input="filterQuickSumsByProjectSelection"
    @filterQuickSumsBySelectionChange="onFilterQuickSumsBySelectionChange"
    label="name"
    trace-by="id"
  >
    <template v-slot:noData>
      <p class="text-xs-center">
        Keine Projekte.
      </p>
      <p class="text-xs-center">
        <router-link :to="{name: 'projects'}">
          Projekte anlegen
        </router-link>
      </p>
    </template>
  </ListSelect>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { api, endpoints } from '@/api'

import ListSelect from '@/components/ListSelect'

export default {
  components: {
    ListSelect,
  },
  data () {
    return {}
  },
  computed: {
    value: {
      get () {
        return this.selectedProjects
      },
      set (value) {
        this.updateSelectedProjects({projects: [...value]})
      }
    },
    ...mapGetters([
      'selectedTenant',
      'profile',
      'selectedProjects',
      'knownProjectSelectables',
      'knownProjectSelectablesLoading',
      'projectQuickSums',
      'projectQuickSumsLoading',
      'filterQuickSumsByProjectSelection'
    ]),
  },
  methods: {
    onFilterQuickSumsBySelectionChange (value) {
      this.updateFilterQuickSumsByProjectSelection({value})
      this.$root.$emit("refreshQuickSums", "project")
    },
    ...mapActions([
      'updateSelectedProjects',
      'updateFilterQuickSumsByProjectSelection',
    ]),
  },
}
</script>
